export const structuredDataJob = (job) => {
    const linkServer = 'https://www.humanprofiler.com';
    let logoLink = "";
    let logoPath = "/images/logo_google_jobs_Human_Profiler.png";
    logoLink = navigator.userAgent !== 'ReactSnap' ? window.location.origin + logoPath : linkServer + logoPath;
    let today = new Date();
    let data = {
        "@context": "http://schema.org/",
        "@type": "JobPosting",
        "datePosted": today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(),
        "hiringOrganization": {
            "@type": "Organization",
            "name": "Human Profiler",
            "sameAs": "https://www.humanprofiler.com/",
            "logo": logoLink
        },
        "directApply": "True",
        "title": job.jobTitle,
        "description": job.functionDescription,
        "jobLocation": {
            "@type": "Place",
            "address": {
                "@type": "PostalAddress",
                "addressLocality": job.location,
                // "addressCountry": job.country_name
            }
        }
    };

    return JSON.stringify(data);
};